import {RteReadMoreLazy} from 'app/modules/editorContent/rteReadMore/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineRteReadMore(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-rte-read-more')) {
        return;
    }

    customElements.define(
        'gem-rte-read-more',
        class extends WebComponentLoader {
            reactLazyComponent = RteReadMoreLazy;
            removePortalContent = false;
            hasConfig = false;
        },
    );
}
